import React from 'react';
import ProposalOverviewContainer from './ProposalOverviewContainer';
import HotelRoomPrefsModal from './HotelRoomPrefsModal';
import TourHotelSendToolbar from './TourHotelSendToolbar';

function showRoomPrefs(groups) {
  for (let i = 0, len = groups.length; i < len; i++) {
    if (((groups[i].hotel_prefs.suites === 0) && (groups[i].hotel_prefs.kings === 0)) && (groups[i].hotel_prefs.queens === 0)) {
      return true;
    }
  }
  return false;
}
class TourHotelSendTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.handleClosePrefs = this.handleClosePrefs.bind(this);
    this.handleShowPrefs = this.handleShowPrefs.bind(this);
  }
  componentWillMount() {
    //this.setState({ show: showRoomPrefs(this.props.tour.groups) });
  }
  handleClosePrefs() {
    this.setState({ show: false });
  }
  handleShowPrefs() {
    this.setState({ show: true });
  }
  render() {
    return (
      <div id="tour-groups" className="bid-manager panel">
        <div className="spacing">
          <TourHotelSendToolbar showRoomPrefs={this.handleShowPrefs} />
          <p />
        </div>
        {this.state.show && (
          <HotelRoomPrefsModal
            tour={this.props.tour}
            savePreferences={this.props.saveRoomPreferences}
            show={this.state.show}
            onClose={this.handleClosePrefs}
          />
        )}
        <ProposalOverviewContainer detailTab={this.props.detailTab} tourId={this.props.tour.id} tourData={this.props.tour} />
      </div>
    );
  }
}
export default TourHotelSendTab;



// WEBPACK FOOTER //
// src/routes/tours/components/TourHotelSendTab.js